/**
 * MLD-2757
 */
import tinymce from 'tinymce';
import {isObject} from 'lodash';

function isPicker(editor, node) {
  if (!isObject(editor) || !isObject(node)) {
    return false;
  }
  return editor.dom.hasClass(node, 'mlPicker');
}

function isEditable(editor, node) {
  if (!isObject(editor) || !isObject(node)) {
    return false;
  }
  const contentEditable = editor.dom.getAttrib(node, 'contenteditable');
  return !(contentEditable === 'false' || editor.dom.hasClass('mceNonEditable'));
}

function unlock(editor, node) {
  if (!isObject(editor) || !isObject(node)) {
    return;
  }
  editor.dom.setAttrib(node, 'contenteditable', '');
  editor.dom.removeClass(node, 'mceNonEditable');
}

function lock(editor, node) {
  if (!isObject(editor) || !isObject(node)) {
    return;
  }
  editor.dom.setAttrib(node, 'contenteditable', 'false');
  editor.dom.addClass(node, 'mceNonEditable');
}

function toggleLock(editor, api) {
  if (!isObject(editor) || !isObject(editor.selection) || !isObject(api)) {
    return;
  }
  const node = editor.selection.getNode();
  if (!node) {
    return;
  }
  if (isPicker(editor, node)) {
    api.setDisabled(true);
    return;
  }
  if (isEditable(editor, node)) {
    //console.log('locking', node.nodeName);
    lock(editor, node);
    api.setActive(true);
  } else {
    //console.log('unlocking', node.nodeName);
    unlock(editor, node);
    api.setActive(false);
  }
}

function configureEditing(editor) {

  // @see https://www.tiny.cloud/docs/ui-components/contextmenu/
  editor.ui.registry.addContextMenu('context_menu_ml_lock', {
    update: (element) => {
      if (isPicker(editor, element)) {
        return '';
      }
      return isEditable(editor, element)
        ? 'menuitem_ml_lock'
        : 'menuitem_ml_unlock';
    }
  });

  editor.ui.registry.addToggleButton('toggle_button_ml_lock', {
    icon: 'lock',
    tooltip: 'Prevent editing of this block',
    onSetup: (api) => {
      api.setActive(!isEditable(editor, editor.selection.getNode()));

      // @see https://www.tiny.cloud/docs/advanced/events/#handlingeditorevents
      editor.on('NodeChange', ({element}) => {
        api.setActive(!isEditable(editor, element));
      })
    },
    onAction: (api) => {
      toggleLock(editor, api)
    }
  })
  // @see https://www.tiny.cloud/docs/ui-components/menuitems/
  editor.ui.registry.addToggleMenuItem('toggle_menuitem_ml_lock', {
    icon: 'lock',
    text: 'Prevent editing of this block',
    onSetup: (api) => {
      api.setActive(!isEditable(editor, editor.selection.getNode()));
    },
    onAction: (api) => {
      toggleLock(editor, api)
    }
  })

  editor.ui.registry.addMenuItem('menuitem_ml_lock', {
    icon: 'lock',
    text: 'Prevent editing of this block',
    onSetup: (api) => {
      api.setDisabled(!isEditable(editor, editor.selection.getNode()));
    },
    onAction: () => {
      lock(editor, editor.selection.getNode());
    }
  })
  editor.ui.registry.addMenuItem('menuitem_ml_unlock', {
    icon: 'unlock',
    text: 'Allow editing of this block',
    onSetup: (api) => {
      api.setDisabled(isEditable(editor, editor.selection.getNode()));
    },
    onAction: () => {
      unlock(editor, editor.selection.getNode());
    }
  })

  // @see https://www.tiny.cloud/docs/ui-components/menuitems/#togglemenuitems
  editor.ui.registry.addToggleMenuItem('toggle_menuitem_ml_highlight_noneditable', {
    text: 'Highlight Non-Editable Blocks',
    icon: 'visualblocks',
    tooltip: 'Show or hide the editable and non-editable sections of the template',
    onSetup: (api) => {
      const elm = editor.dom.select('#tinymce')
      if (editor.dom.hasClass(elm, 'EditMode')) {
        api.setActive(true);
      } else {
        api.setActive(false);
      }
    },
    onAction: (api) => {
      //const container = editor.getContainer();
      const elm = editor.dom.select('#tinymce');
      if (api.isActive()) {
        editor.dom.removeClass(elm, 'EditMode')
        api.setActive(false);
        console.log('Turned off EditMode');
      } else {
        editor.dom.addClass(elm, 'EditMode');
        api.setActive(true);
        console.log('Turned on EditMode');
      }
      //api.setActive(!api.isActive());
    },
  })
  editor.ui.registry.addToggleButton('ml_show_editable', {
    text: 'Highlight Non-Editable Areas',
    tooltip: 'Show or hide the editable and non-editable sections of the template',
    onSetup: (api) => {
      const elm = editor.dom.select('#tinymce')
      editor.dom.addClass(elm, 'EditMode');
      api.setActive(true);
    },
    onAction: (api) => {
      //const container = editor.getContainer();
      const elm = editor.dom.select('#tinymce');
      if (api.isActive()) {
        editor.dom.removeClass(elm, 'EditMode')
        api.setActive(false);
      } else {
        editor.dom.addClass(elm, 'EditMode');
        api.setActive(true);
      }
      //api.setActive(!api.isActive());
    },
  });
}

tinymce.PluginManager.add('mobilelockereditor', (editor, url) => {

  configureEditing(editor);

  // @see https://www.tiny.cloud/docs/ui-components/contextmenu/
  editor.ui.registry.addContextMenu('context_menu_ml_insert_tag', {
    update: (element) => {
      return 'menuitem_ml_insert_tag';
    }
  })

  return {
    name: 'Mobile Locker Editor',
    url: 'https://www.mobilelocker.com',
  }
})

export default {
  isEditable,
  isPicker,
  lock,
  tinymce,
  toggleLock,
  unlock,
}
